/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AllegatoCopiabileDTO } from './allegato-copiabile-dto';


export interface PropostaCloneDTO { 
    form_data?: { [key: string]: any; };
    negozi_ids?: Array<string>;
    allegati_copiabili?: Array<AllegatoCopiabileDTO>;
    mancanti?: Array<string>;
    campi_non_mappati?: Array<string>;
    completa?: boolean;
    dichiarazioni_mancanti?: Array<string>;
}

